<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { locationsApi } from '@/api/client'
import { useAuthStore } from '@/store/auth'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

onMounted(async () => {
  const supportToken = route.query.supportToken as string | undefined
  const organizationId = route.query.organizationId as string | undefined
  const locationId = route.query.locationId as string | undefined

  if (!supportToken || !organizationId || !locationId) {
    router.push({ name: 'login' })
    return
  }

  const ok = await authStore.supportLogin({
    accessToken: supportToken,
    organizationId,
    locationId
  })
  if (!ok) {
    router.push({ name: 'login' })
    return
  }

  const locations = await locationsApi.getRiderLocations()
  const current = locations.find(l => l.id === locationId)
  if (current) {
    await authStore.selectLocation(current)
    router.push({ name: 'customerDisplay' })
  } else {
    router.push({ name: 'locationSelector' })
  }
})
</script>
